// projects/humanresources-general/src/assets/i18n/*/hr-gen-hrm-detail-type.json
export class HrGenHrmDetailTypeKey {
    private static readonly keyPrefix = 'hrGenHrmDetailType';
    public static pageHeader = `${HrGenHrmDetailTypeKey.keyPrefix}.pageHeader`;
    public static detailId = `${HrGenHrmDetailTypeKey.keyPrefix}.detailId`;
    public static timeConstraint = `${HrGenHrmDetailTypeKey.keyPrefix}.timeConstraint`;
}
